import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e0814a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "horizontal"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "horizontal--bounce1" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "horizontal--bounce2" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "horizontal--bounce3" }, null, -1))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

import { ref, onMounted, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CLoadingIndicator',
  props: {
    type: { default: 'circle' },
    size: { default: '' },
    show: { type: Boolean, default: false }
  },
  setup(__props: any) {

// TODO vue3: replace component with t-progress !?
const props = __props
let timer: NodeJS.Timer
const off = ref(false)

onMounted(() => {
  // this is required to not show the animation in case off show is initial false
  if (props.show === false) {
    off.value = true
  } else {
    off.value = false
  }
})

watch(
  () => props.show,
  () => {
    if (!props.show) {
      setTimeout(() => {
        // this.$refs.loadingIndicator.style.display = this.show ? "flex" : "none"
        off.value = true
      }, 500)
    } else {
      off.value = false
    }
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    "data-qe-id": "loader-indicator",
    ref: "loadingIndicator",
    class: _normalizeClass(["loadingIndicator", `${_ctx.show ? 'active' : 'inactive'} ${off.value ? 'off' : ''}`])
  }, [
    (_ctx.type === 'circle')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["circle", _ctx.size])
        }, null, 2))
      : _createCommentVNode("", true),
    (_ctx.type === 'horizontal')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
      : _createCommentVNode("", true)
  ], 2))
}
}

})